import { Component, Input } from "@angular/core";

@Component({
    selector: 'bn-badge-counter-ui',
    template: `
    <div class="bb-badge-counter">
        <span 
            class="badge badge-counter"
            [ngClass]="'badge-counter-' + color"
            [ngClass]="{ 'border border-light rounded': border }"
        >{{ count }}</span>
    </div>
    `,
    styles: [ '.bb-badge-counter { padding-top: 0.125rem; }' ]
})
export class BadgeCounterComponent {
    @Input() count: number = 0;
    @Input() color = 'primary';
    @Input() border = false;
}